import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import {
  AdditionalPersonalStatisticRequestType,
  AdditionalPersonalStatisticResponseType,
  MFStatisticRequestType,
  MFStatisticResponseType,
  StatisticWidgetFullInfoType,
  StatisticWidgetsBulkRequestType,
  StatisticWidgetsBulkResponseType,
} from '@app/interfaces/qm-module/qm-statistic/qm-statistic.type';

import { baseQuery } from '../../../baseQuery';

export const qmStatisticApi = createApi({
  reducerPath: 'qmStatisticApi',
  tagTypes: [],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getStatisticMFSList: build.query<MFStatisticResponseType, MFStatisticRequestType>({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_statistic_monitoring_forms_list,
        params,
        body,
        method: 'POST',
      }),
    }),
    getStatisticMFSListExport: build.query<Blob, MFStatisticRequestType>({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_statistic_monitoring_forms_list_export,
        params,
        body,
        responseHandler: (res) => res.blob(),
        method: 'POST',
      }),
    }),
    getStatisticWidgets: build.query<
      StatisticWidgetsBulkResponseType,
      Partial<StatisticWidgetsBulkRequestType>
    >({
      query: (body) => ({
        url: serverRoutes.qm_statistic_widgets_bulk,
        body,
        method: 'POST',
      }),
    }),
    getStatisticWidgetFullInfo: build.query<
      StatisticWidgetFullInfoType,
      { body: Partial<StatisticWidgetsBulkRequestType>; params: { mform_id: string } }
    >({
      query: ({ body, params }) => ({
        url: serverRoutes.qm_statistic_widgets,
        body,
        params,
        method: 'PUT',
      }),
    }),
    // additional opers & teams
    getStatisticOperatorInfo: build.query<
      AdditionalPersonalStatisticResponseType<'operators'>,
      AdditionalPersonalStatisticRequestType<'operators'>
    >({
      query: ({ body, params }) => ({
        url: serverRoutes.qm_statistic_operators,
        body,
        params,
        method: 'PUT',
      }),
    }),
    getStatisticTeamsInfo: build.query<
      AdditionalPersonalStatisticResponseType<'teams'>,
      AdditionalPersonalStatisticRequestType<'teams'>
    >({
      query: ({ body, params }) => ({
        url: serverRoutes.qm_statistic_teams,
        body,
        params,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetStatisticMFSListQuery,
  useGetStatisticWidgetsQuery,
  useLazyGetStatisticWidgetFullInfoQuery,
  useGetStatisticOperatorInfoQuery,
  useGetStatisticTeamsInfoQuery,
  useLazyGetStatisticMFSListExportQuery,
} = qmStatisticApi;
